var map = {
	"./bnb.png": "3d80",
	"./btc.png": "960e",
	"./cashapp.png": "c290",
	"./credit.png": "a622",
	"./csgo.png": "6b28",
	"./dota.png": "feb0",
	"./eth.png": "50e6",
	"./ether.png": "c894",
	"./g2a.png": "ffcc",
	"./gift.png": "b596",
	"./kinguin.png": "e26b",
	"./limiteds.png": "4141",
	"./ltc.png": "d607",
	"./placeholder.png": "efe4",
	"./polygon.png": "2dfa",
	"./robux.png": "ee1b",
	"./solana.png": "494b",
	"./trx.png": "48e2",
	"./usdc.png": "d2e2",
	"./usdt.png": "5f01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0403";